import script from "./DataGovernance.vue?vue&type=script&setup=true&lang=js"
export * from "./DataGovernance.vue?vue&type=script&setup=true&lang=js"

import "./DataGovernance.vue?vue&type=style&index=0&id=3eaef933&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eaef933"]])

export default __exports__